import { apiFetch } from '@/plugins/apiFetch'

export const improveWriting = async (params, onChunk) => {

    const response = await apiFetch('/api/ai/text-actions', {
        method: 'POST',
        headers: {
            'Accept': 'text/event-stream',
        },
        body: JSON.stringify(params),
    })

    const reader = response.body.getReader()
    const decoder = new TextDecoder()
    
    while (true) {
        const { done, value } = await reader.read()
        if (done) break
        const chunk = decoder.decode(value)
        const lines = chunk.split('\n')
        for (const line of lines) {
            if (!line.startsWith('data:')) {
                continue
            }
            const data = line.replace('data:', '').trim()
            if (data === '[DONE]') {
                return
            }
            try {
                const parsed = JSON.parse(data)
                onChunk(parsed)
            } catch (e) {
                console.error('Error parsing SSE chunk', e)
            }
        }
    }
}